import md5 from 'js-md5';
import { queryUserInfo } from '@/common/request';

let pendingRequest = null;
let generation = 0;

function syncAccountId(userInfo) {
  try {
    window.dw?.setAccountId(userInfo ? md5(String(userInfo.userid)) : '');
  } catch (error) {
    console.warn('[account] tracking identity update failed', error);
  }
}

export default {
  namespaced: true,
  state: () => ({ userInfo: null, status: 'idle' }),
  getters: {
    identityType(state) {
      if (state.status !== 'loaded') return null;
      if (!state.userInfo) return 'unlogin';
      return state.userInfo.companyid ? 'company' : 'personal';
    },
  },
  mutations: {
    setAccount(state, { userInfo = null, status }) {
      state.userInfo = userInfo;
      state.status = status;
    },
  },
  actions: {
    ensureUserInfo({ state, commit }) {
      if (state.status === 'loaded') return state.userInfo;
      if (pendingRequest) return pendingRequest;
      const requestGeneration = generation;
      commit('setAccount', { status: 'loading' });
      pendingRequest = queryUserInfo()
        .then((userInfo) => {
          if (requestGeneration !== generation) return null;
          commit('setAccount', { userInfo, status: 'loaded' });
          syncAccountId(userInfo);
          return userInfo;
        })
        .catch((error) => {
          if (requestGeneration === generation) {
            commit('setAccount', { status: 'error' });
            console.warn('[account] user info load failed', error);
          }
          return null;
        })
        .finally(() => {
          if (requestGeneration === generation) pendingRequest = null;
        });
      return pendingRequest;
    },
    clearUserInfo({ commit }) {
      generation += 1;
      pendingRequest = null;
      commit('setAccount', { status: 'idle' });
      syncAccountId(null);
    },
    async refreshUserInfo({ dispatch }) {
      await dispatch('clearUserInfo');
      return dispatch('ensureUserInfo');
    },
  },
};
